module.exports = __webpack_public_path__ + "static/media/group_copy_3@3x.7e8d4368.jpg";